// extracted by mini-css-extract-plugin
export default {"list":"NavSubgroup_list__6svp0","name":"NavSubgroup_name__5zROY"};